import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AtendimentoService } from '../../../modules/cadastro/services/atendimento.service';

@Component({
  selector: 'app-lead-novo-documento',
  standalone: false,
  templateUrl: './lead-novo-documento.component.html',
  styleUrls: ['./lead-novo-documento.component.css']
})
export class LeadNovoDocumentoComponent {
  @Input() showModal = false;
  @Input() atendimentoId: number | null = null;
  @Output() fecharModalPai = new EventEmitter<void>();
  @Output() enviado = new EventEmitter<{ atendimentoId: number | null, file?: File, sucesso?: boolean }>();

  selectedFile?: File;

  constructor(private atendimentoService: AtendimentoService) {}

  onBackgroundClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('box-novo-compromisso')) {
      this.fecharModal();
    }
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  enviar() {
    if (!this.selectedFile || !this.atendimentoId) {
      // apenas emite se faltar dados
      this.enviado.emit({ atendimentoId: this.atendimentoId ?? null, file: this.selectedFile, sucesso: false });
      return;
    }

    // Origem e Caminho devem ser strings vazias conforme requisito
    this.atendimentoService
      .uploadArquivo(this.atendimentoId, this.selectedFile, '', '')
      .subscribe({
        next: () => {
          this.enviado.emit({ atendimentoId: this.atendimentoId, file: this.selectedFile, sucesso: true });
          this.fecharModal();
        },
        error: () => {
          this.enviado.emit({ atendimentoId: this.atendimentoId, file: this.selectedFile, sucesso: false });
        }
      });
  }

  fecharModal() {
    this.showModal = false;
    this.fecharModalPai.emit();
  }
}
